// extracted by mini-css-extract-plugin
export default {"styles":"_1eIwk_qJvO8uWqztJ6as"};